import { render, staticRenderFns } from "./CategorySelector.vue?vue&type=template&id=56d5e14a"
import script from "./CategorySelector.vue?vue&type=script&lang=js"
export * from "./CategorySelector.vue?vue&type=script&lang=js"
import style0 from "./CategorySelector.vue?vue&type=style&index=0&id=56d5e14a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports